module.exports = __webpack_public_path__ + "media/audio7.7278835e.mp3";